export default __webpack_public_path__ + "static/media/Logo-printcart-new.26748821.svg";